import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/StaffThumbnail1.css';
import { isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { getProfileImage, getProfileObjectFit } from '../../../../catalog/Website';

const StaffThumbnail1 = (props) => {
    const { staff } = props;
    const { globalState } = useContext(context);

    const getStaffInfo = (details, infoTitle) => {
        let info = '';
        details.forEach((detail) => {
            if (detail.title === infoTitle) {
                info = detail.value;
            }
        });
        return info;
    };

    return (
        <div key={staff.id} className="staff-thumbnail1-container curve-border-20px text-black text-no-underline m-t-20px m-b-20px p-t-5px p-b-5px p-l-50px p-r-10px">
            <div className="staff-thumbnail1-main-info-container">
                <img className="staff-thumbnail1-image curve-border-10px" src={getProfileImage(globalState, staff.profileImage)} alt={isValidString(staff.name) ? staff.name : 'Executive Board Profile Image'} style={{ objectFit: getProfileObjectFit(globalState, staff.profileImage) }} />
                <div className="staff-thumbnail1-name-container m-l-30px m-r-30px">
                    <p className="staff-thumbnail1-subname alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-l">{getStaffInfo(staff.details, 'Title')}</p>
                    <p className="staff-thumbnail1-name alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-3xl">{staff.name}</p>
                    <p className="staff-thumbnail1-subname-black alegreya-font-family font-weight-800 text-left-align m-t-0 m-b-0 text-uppercase font-size-l">{getStaffInfo(staff.details, 'Hometown')}</p>
                </div>
                <p className="staff-thumbnail1-year m-t-0 m-b-0 m-l-30px text-center-align text-capitalize font-size-l">{getStaffInfo(staff.details, 'Year')}</p>
            </div>
            <div className="staff-thumbnail1-side-info-container">
                <div className="staff-thumbnail1-side-info">
                    {isValidString(staff.email) && staff.showEmail ? (<a className="staff-thumbnail1-side-info-text text-right-align text-no-underline m-t-5px m-b-5px m-r-10px text-uppercase font-size-l" href={`mailto:${staff.email}`}>{`Email: ${staff.email}`}</a>) : null}
                    {isValidString(staff.phone) && staff.showPhone ? (<a className="staff-thumbnail1-side-info-text text-right-align text-no-underline m-t-5px m-b-5px m-r-10px text-uppercase font-size-l" href={`tel:${staff.phone}`}>{`Phone: ${staff.phone}`}</a>) : null}
                </div>
            </div>
        </div>
    );
};

StaffThumbnail1.propTypes = {
    staff: PropTypes.object.isRequired,
};

export default memo(StaffThumbnail1);
